/* eslint-disable */

import React, { Component } from 'react';
import LinkAccount from './components/01_LinkAccount';
import Domains from './components/02_Domains';
import ActivateDomains from './components/03_ActivateDomains';
import AddUsers from './components/04_AddUsers';
import TrackGoogleDiscover from './components/06_TrackGoogleDiscover';
import AuthorReports from './components/07_AuthorReports';
import BrandedTerms from './components/08_BrandedTerms';
import SearchBehavior from './components/10_SearchBehavior';
import AddTaxIdOrVat from './components/10_AddTaxIdOrVat';
import AddAdditionalEmails from './components/05_AddAdditionalEmails';
// import AdditionalAddOns from './components/AdditionalAddOns';

function getIsEmptyProfile(obj) {
    for (let key in obj) {
        if (obj[key]) return false;
    }
    return true;
}

class Onboarding extends Component {
    constructor(props) {
        super();

        this.showOpened = this.showOpened.bind(this);
        this.onClickOnStep = this.onClickOnStep.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.selectAccount = this.selectAccount.bind(this);
        this.onAddUsers = this.onAddUsers.bind(this);
        this.finishSteps = this.finishSteps.bind(this);
        this.isDisabled = this.isDisabled.bind(this);

        this.domains = JSON.parse(props.domains);
        this.profile = JSON.parse(props.profile);
        this.available_accounts = JSON.parse(props.available_accounts);

        const isActiveDomain = this.domains?.find((item) => item.status);
        const isEmptyProfile = getIsEmptyProfile(this.profile);

        const isFinished = isActiveDomain && !isEmptyProfile;
        const alreadySelectedAccountId = localStorage.getItem('onboarding_account_id');
        let alreadySelectedAccount = null;
        if (alreadySelectedAccountId) {
            alreadySelectedAccount = this.available_accounts.find(
                (item) => item.account_id === alreadySelectedAccountId,
            );
        }

        this.state = {
            allData: [],
            isLoading: true,
            selectedCollapse: isFinished ? 0 : this.domains?.length > 0 ? 3 : 1,
            paymentInformation: null,
            selectedAccount: alreadySelectedAccount,
            users_remaining_count: Number(props.users_remaining_count),
            users_total_number_of_available: Number(props.users_total_number_of_available),
            isFinished,
        };
    }

    selectAccount(account) {
        localStorage.setItem('onboarding_account_id', account.account_id);
        this.setState({
            selectedAccount: account,
        });
        this.handleNext(1); // current step is 1
    }

    onClickOnStep(id) {
        this.setState({
            selectedCollapse: this.state.selectedCollapse === id ? null : id,
        });
    }

    showOpened(name, value) {
        return this.state.selectedCollapse === name ? value ?? 'active' : '';
    }

    handleNext(id) {
        const index = this.data.findIndex((item) => item.id === id);
        const nextId = this.data[index + 1].id;
        this.setState({
            selectedCollapse: nextId,
        });
    }

    handleBack(id) {
        const index = this.data.findIndex((item) => item.id === id);
        const prevId = this.data[index - 1].id;
        this.setState({
            selectedCollapse: prevId,
        });
    }

    onAddUsers(count) {
        this.setState({
            users_remaining_count: this.state.users_remaining_count - count,
        });
    }

    finishSteps() {
        this.setState({
            isFinished: true,
            selectedCollapse: 0,
        });
        setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
    }

    isDisabled(id) {
        switch (id) {
            case 1:
                return false;
            case 2: {
                if (
                    this.available_accounts.length === 0 ||
                    (!this.state.selectedAccount && this.domains.length === 0)
                )
                    return true;
                return false;
            }
            case 3: {
                if (this.domains.length === 0) return true;
                return false;
            }
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10: {
                if (
                    this.available_accounts.length === 0 ||
                    this.domains.length === 0 ||
                    !this.domains.find((item) => item.status)
                )
                    return true;
                return false;
            }
            default: {
                return false;
            }
        }
    }

    render() {
        const usersCount =
            this.props.users_total_number_of_available - this.props.users_remaining_count;

        this.data = [
            {
                id: 1,
                name: (
                    <>
                        <div>
                            <div>Connect your Google Search Console</div>
                            <div className="onboarding-container-item-body-header-subtitle">
                                First, let’s link your Google Search Console account to get started
                            </div>
                        </div>
                        <a
                            href="/customers/link?gd_src=from_onboard"
                            className={`button button-primary ${
                                this.available_accounts.length ? 'button-outline' : 'button-filled'
                            }`}
                        >
                            {this.available_accounts.length
                                ? 'Add additional GSC Account'
                                : 'Connect GSC Account'}
                        </a>
                    </>
                ),
                component: (
                    <LinkAccount
                        account={this.props.gd_src}
                        domains={this.domains}
                        available_accounts={this.available_accounts}
                        csrf_token={this.props.csrf_token}
                        selectAccount={this.selectAccount}
                    />
                ),
            },
            {
                id: 2,
                name: (
                    <div>
                        <div>Select Your Domains</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            Choose all the domains you'd like to add to our tool.
                        </div>
                    </div>
                ),
                component: (
                    <Domains
                        csrf_token={this.props.csrf_token}
                        domains={this.domains}
                        selectedAccount={this.state.selectedAccount}
                        handleNext={() => this.handleNext(2)}
                        handleBack={() => this.handleBack(2)}
                        // isDisabledNext={this.isDisabled(3)}
                    />
                ),
            },
            {
                id: 3,
                name: (
                    <div>
                        <div>Activate Domains for Trial</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            Which of these domains would you like to activate for the trial period?
                        </div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            You can activate one free domain during trial.
                        </div>
                    </div>
                ),
                component: (
                    <ActivateDomains
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        handleNext={() => this.handleNext(3)}
                        handleBack={() => this.handleBack(3)}
                        isDisabledNext={this.isDisabled(4)}
                    />
                ),
            },
            {
                id: 4,
                name: (
                    <div>
                        <div>Add Users (Optional)</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            {usersCount} of {this.props.users_total_number_of_available} seats used
                        </div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            Would you like to invite other users to access the tool and reports? You
                            can also do this later in Settings.
                        </div>
                    </div>
                ),
                component: (
                    <AddUsers
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        users_remaining_count={this.state.users_remaining_count}
                        users_total_number_of_available={this.state.users_total_number_of_available}
                        onAddUsers={this.onAddUsers}
                        handleNext={() => this.handleNext(4)}
                        handleBack={() => this.handleBack(4)}
                    />
                ),
            },
            {
                id: 5,
                name: (
                    <div>
                        <div>Add Additional Emails (Optional)</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            Add other users to receive weekly and monthly performance emails. These
                            users will not have access to the tool but will receive performance
                            reports via email.
                        </div>
                    </div>
                ),
                component: (
                    <AddAdditionalEmails
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        users_remaining_count={this.state.users_remaining_count}
                        users_total_number_of_available={this.state.users_total_number_of_available}
                        onAddUsers={this.onAddUsers}
                        handleNext={() => this.handleNext(5)}
                        handleBack={() => this.handleBack(5)}
                    />
                ),
            },
            {
                id: 6,
                name: (
                    <div>
                        <div>Track Google Discover</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            Our tool can track Google Discover and identify viral stories and top
                            competitors. Please provide a key entity important to you (e.g., Taylor
                            Swift or any topic you write about frequently).
                        </div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            Your Trial Account comes with 1 Entity Tracking. You are tracking{' '}
                            {this.props.tracking_entity ? 1 : 0} so far.{' '}
                            {this.props.tracking_entity
                                ? 'Please go to the next step.'
                                : 'Please add an entity below to track.'}
                        </div>
                    </div>
                ),
                component: (
                    <TrackGoogleDiscover
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        handleNext={() => this.handleNext(6)}
                        handleBack={() => this.handleBack(6)}
                        tracking_entity={this.props.tracking_entity}
                    />
                ),
            },
            {
                id: 7,
                name: (
                    <div>
                        <div>Author Reports (Optional)</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            We offer reports that highlight each author’s performance on Google
                            Discover. Some European countries restrict these reports. Would you like
                            to:
                        </div>
                    </div>
                ),
                component: (
                    <AuthorReports
                        csrf_token={this.props.csrf_token}
                        handleNext={() => this.handleNext(7)}
                        handleBack={() => this.handleBack(7)}
                    />
                ),
            },
            {
                id: 8,
                name: (
                    <div>
                        <div>Branded Terms</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            What are your branded terms? (e.g., your domain name, brand name, etc.)
                        </div>
                    </div>
                ),
                component: (
                    <BrandedTerms
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        handleNext={() => this.handleNext(8)}
                        handleBack={() => this.handleBack(8)}
                    />
                ),
            },
            {
                id: 9,
                name: (
                    <div>
                        <div>Search Behavior</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            Define the search behavior
                        </div>
                    </div>
                ),
                component: (
                    <SearchBehavior
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        handleNext={() => this.handleNext(9)}
                        handleBack={() => this.handleBack(9)}
                    />
                ),
            },
            // {
            //     id: 9,
            //     name: 'Additional Add-Ons',
            //     component: (
            //         <AdditionalAddOns
            //             csrf_token={this.props.csrf_token}
            //             handleNext={() => this.handleNext(9)}
            //             handleBack={() => this.handleBack(9)}
            //         />
            //     ),
            // },
            {
                id: 10,
                name: (
                    <div>
                        <div>Billing Settings (Optional): Add Tax ID or VAT</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            Would you like to add a Tax ID or VAT to your invoice? You can also do
                            this later.
                        </div>
                    </div>
                ),
                component: (
                    <AddTaxIdOrVat
                        csrf_token={this.props.csrf_token}
                        tax_id_types={this.props.tax_id_types}
                        handleNext={() => this.handleNext(10)}
                        handleBack={() => this.handleBack(10)}
                        profile={this.profile}
                        finishSteps={this.finishSteps}
                    />
                ),
            },
        ];

        return (
            <>
                <div className="onboarding-container">
                    <div className="onboarding-container-header">
                        <h2>Welcome to GDdash Account!</h2>
                        <div>
                            We’re excited to have you on board! Let’s get started by setting up your
                            account. This quick setup will ensure you unlock the full potential of
                            our tool and customize it to your needs. Follow the steps below to
                            complete your setup. Most steps are quick and easy, and we’ve marked
                            optional ones so you can skip them if they’re not relevant right now.
                        </div>
                    </div>

                    {this.state.isFinished && (
                        <div className="onboarding-all-done-box">
                            <div className="onboardin-card">
                                <img src="/static/img/onboarding-all-done.svg" alt="all-done-img" />
                                <div>
                                    <div className="onboarding-all-done-box-header">
                                        You’re all set!
                                    </div>
                                    <div className="onboarding-all-done-box-body">
                                        We're analyzing your Google Discover data from the{' '}
                                        <strong>past 30 days</strong> and will update daily after
                                        that. We'll also crawl your site and analyze your
                                        content.You reports will be ready in 2-3 days. Check back
                                        soon for your personalized insights! We will  once you data
                                        is in and fully analyzed.
                                        <div className="mt-10">
                                            For the time being you can start with your{' '}
                                            <a href="/tools/google-discover-data/">
                                                Google Discover Tracking report
                                            </a>
                                            , it should be available in 30 minutes.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {this.data.map((item) => (
                        <div
                            className="onboarding-container-item"
                            key={item.id}
                            style={{
                                opacity:
                                    this.isDisabled(item.id) || this.state.isFinished ? '0.3' : '1',
                            }}
                        >
                            <div className={`onboarding-container-item-number`}>{item.id}</div>
                            <div className="onboarding-container-item-body">
                                <div
                                    className={`onboarding-container-item-body-header ${this.showOpened(
                                        item.id,
                                        'show',
                                    )}`}
                                    onClick={() =>
                                        !(this.state.isFinished && this.isDisabled(item.id))
                                            ? this.onClickOnStep(item.id)
                                            : null
                                    }
                                >
                                    <div className="onboarding-container-item-body-header-left">
                                        {item.name}
                                    </div>
                                    <button className="arrow-icon">
                                        <i className="icon-chevron-right" />
                                    </button>
                                </div>
                                <div
                                    className={`onboarding-container-item-body-content ${this.showOpened(
                                        item.id,
                                        'show',
                                    )}`}
                                >
                                    {item.component ?? 'In Process'}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </>
        );
    }
}

export default Onboarding;
